import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as api from '../services/api';
import ShareFavourites from "../components/Favourites/ShareFavourites";
import { loadRecaptcha } from 'react-recaptcha-v3'
import FlashMessage from "../components/Favourites/FlashMessage";

export class ShareItineraryApp extends Component {

    static propTypes = {
        reCaptchaSiteKey: PropTypes.string,
        itineraryUid: PropTypes.number,
        excursionUid: PropTypes.number
    };

    initialState = {
        flashMessages: []
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

	componentDidMount() {
        loadRecaptcha(this.props.reCaptchaSiteKey);
	}

	sendFavouritesEmail = (email, recaptchaToken, callBack) => {
        api.sendFavouritesEmail(this.props.itineraryUid.toString(), this.props.excursionUid.toString(), email, recaptchaToken)
            .then(
                response => {
                    this.setState({flashMessages: [{level: 'ok', messageKey: 'ok'}]});
                    callBack();
                },
                error => {
                    console.log(error);
                    this.setState({flashMessages: [{level: 'error', messageKey: 'error'}]})
                }
            );
    };

    clearFlashMessages = () => {
        this.setState({flashMessages: []});
    };

	render() {
    	const {flashMessages} = this.state;
    	const {reCaptchaSiteKey} = this.props;

		return (
			<div>
                <div className='shareContainer'>
                    <ShareFavourites siteKey={reCaptchaSiteKey} sendFavouritesEmail={this.sendFavouritesEmail} clearFlashMessages={this.clearFlashMessages} shareButtonLabel={'itinerary_detail.show_email_button'} />
                    <div className='flashMessageContainer'>
                        {flashMessages.map(flashMessage => <FlashMessage messageKey={flashMessage.messageKey} level={flashMessage.level} />)}
                    </div>
                </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/apps/ShareItineraryApp.js